import { useLayoutEffect } from '@radix-ui/react-use-layout-effect';
import { useState } from 'react';

const FDS_POPPERS = [
  // Modal, PopConfirm
  {
    selector: ".ant-modal",
    zIndex: 1060
  },
  // Dropdown, Picker
  {
    selector: ".ant-select-open, .ant-picker-dropdown:not(.ant-picker-dropdown-hidden)",
    zIndex: 1050
  },
  // Popover
  {
    selector: ".ant-popover:not(.ant-popover-hidden)",
    zIndex: 1030
  },
  /**
   * Drawer
   * NOTE: https://flex-cv82520.slack.com/archives/C05K420G6RK/p1692003855099929?thread_ts=1692001210.204099&cid=C05K420G6RK
   */
  {
    selector: ".ant-drawer-wrapper-body",
    zIndex: 1e3
  }
];
function usePopperZIndexStyle(open, forcedZIndex) {
  const [zIndex, setZIndex] = useState();
  useLayoutEffect(() => {
    if (open) {
      const fdsPopperZIndex = FDS_POPPERS.find(
        ({ selector }) => document.querySelector(selector)
      )?.zIndex;
      if (fdsPopperZIndex) {
        setZIndex(fdsPopperZIndex + 1);
      }
    }
  }, [open]);
  if (forcedZIndex === void 0 && zIndex === void 0) {
    return {};
  }
  return { zIndex: forcedZIndex ?? zIndex };
}

export { usePopperZIndexStyle };
//# sourceMappingURL=usePopperZIndexStyle.mjs.map
